import Vue from 'vue';
import App from './app.vue';
import '../../utils/common.js';

new Vue({
  el: '#app',
  render: h => h(App)
});
